import React from 'react';
import './styles.css';

const Footer = () => (
  <div className="footer">
    <div className="top-section">
      <div className="logo">
        <span className="icon-logo" />
        <h1>Húsfinnur</h1>
      </div>
      <div className="social">
        <a href="https://www.facebook.com/husfinnur" target="_blank" rel="noopener noreferrer" className="facebook">
          <span className="icon-facebook-icon" />
          <p>Finndu okkur á Facebook!</p>
        </a>
        <a href="mailto:rentimizer@reon.is" target="_blank" rel="noopener noreferrer" className="email">
          <span className="icon-email-icon" />
          <p>Sendu okkur tölvupóst!</p>
        </a>
      </div>
    </div>
    <div className="bottom-section">
      <a href="http://reon.is/" target="_blank" rel="noopener noreferrer">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/rentimizer-e5308.appspot.com/o/reon-white-logo.png?alt=media&token=068558d9-90e6-4fea-8529-369d332ef483"
          role="presentation"
          className="reon-logo"
        />
      </a>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/browser/app/components/Footer/Footer.js